import styles from './Stack.module.css';

interface StackProps {
  children: React.ReactNode;
  gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  align?: 'left' | 'center' | 'right';
  as?: React.ElementType;
  className?: string;
}

export function Stack({ children, gap = 'md', align = 'left', as: Tag = 'div', className = '' }: StackProps) {
  return (
    <Tag className={[styles.stack, styles[gap], styles[align], className].filter(Boolean).join(' ')}>
      {children}
    </Tag>
  );
}
